/**
 * A person as the screen names them: their real name when there is one, otherwise their email. Never blank, so a card or a menu never shows an empty label for a pre-provisioned
 * account that has not signed in yet.
 *
 * `||`, not `??`, deliberately: an account with no name parts joins to the EMPTY STRING, and the
 * empty string is exactly the case that should fall back to the email.
 */
export const displayName = (user: {
    first_name: string | null;
    last_name: string | null;
    email: string;
}): string => [user.first_name, user.last_name].filter(Boolean).join(' ').trim() || user.email;

/** The first word of a display name — "Ana" from "Ana Silva" — or the whole thing when there is one word. */
export const firstNameOf = (name: string): string => name.trim().split(/\s+/)[0] ?? name;
